
import { CompanyUserService } from "@/services/company-user-service";
import { CompanyService } from "@/services/company-service";
import { Dossier } from "@/models/dossier";
import { User } from "@/models/user";
import { IDataTableColumn } from "winfakt-vue-components/src/classes";
import Vue from "vue";

interface IDossierResult {
	ID:number;
	Name:string;
	CompanyID:number;
	CompanyName:string;
}

export default Vue.extend({
	data() {
		return {
			dossiers: [] as Dossier[],
			search: "",
			searchResults: [] as IDossierResult[],
			selectedDossierId: 0,
			selectedRows: [] as Dossier[]
		};
	},
	props: {
		user: {
			type: Object as () => User,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[] {
			return [
				{name: "ID", property: "id", width: "80px"},
				{name: "Naam", property: "name"},
				{name: "Company ID", property: "companyId", width: "120px"}
			];
		}
	},
	watch: {
		"user.id": {
			immediate: true,
			handler(id:number) {
				if (id) this.refresh();
			}
		}
	},
	methods: {
		async refresh() {
			this.dossiers = await CompanyUserService.getAccountantDossiers(this.user.companyId, this.user.id);
			this.selectedRows = [];
		},
		onTextChange() {
			this.selectedDossierId = 0;
		},
		async doSearch(query:string) {
			if (this.selectedDossierId) return;
			this.searchResults = await CompanyService.searchDossiers(query);
		},
		onPick(item:IDossierResult) {
			this.search = `${item.Name} — ${item.CompanyName} (#${item.ID})`;
			this.selectedDossierId = item.ID;
		},
		onRowClick(d:Dossier) {
			let idx = this.selectedRows.findIndex(x => x.id == d.id);
			if (idx >= 0) {
				this.selectedRows.splice(idx, 1);
			} else {
				this.selectedRows.push(d);
			}
		},
		async add() {
			if (!this.selectedDossierId) return;
			try {
				await CompanyUserService.addAccountantDossier(this.user.companyId, this.user.id, this.selectedDossierId);
				this.search = "";
				this.selectedDossierId = 0;
				this.searchResults = [];
				await this.refresh();
			} catch (err) {
				this.$wf.notify("Kon dossier niet koppelen", "error", 4000, "exclamation-triangle");
			}
		},
		async removeSelected() {
			if (this.selectedRows.length == 0) return;
			let ok = await this.$wf.confirm(`${this.selectedRows.length} dossier(s) ontkoppelen van deze boekhouder?`, "Ontkoppelen", "Annuleer", "Bevestig", "warning");
			if (!ok) return;
			for (let d of this.selectedRows) {
				await CompanyUserService.removeAccountantDossier(this.user.companyId, this.user.id, d.id);
			}
			await this.refresh();
		}
	}
});
